import { FC } from 'react'

import { MerchantLogo } from '@mxenabled/mxui'

import type { WeGotTheBeat } from '../interfaces'

const BeatMerchantLogo: FC<WeGotTheBeat> = ({ beat }) => {
  const { category_guids, merchant_guids, primary_category_guid, primary_merchant_guid } = beat
  return (
    <MerchantLogo
      categoryGuid={primary_category_guid || (category_guids && category_guids[0]) || ''}
      merchantGuid={primary_merchant_guid || merchant_guids[0]}
      size={32}
      sx={{
        display: 'flex',
        mt: 2,
        minWidth: 32,
      }}
    />
  )
}

export default BeatMerchantLogo
